import { broadcast, broadcastChannels } from './broadcast';
import Helpers from './helperFunctions';

export const changeSecondScreen = (config, detail) => {
  if (!Helpers.isSecondScreenAvailable(config)) return false;

  broadcast.dispatchEvent(new CustomEvent(broadcastChannels.SecondScreenChange, {
    detail,
  }));

  return true;
};
